import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, } from 'react';
import Modal from '../../molecules/Modal';
import Flex from '../../atoms/Flex';
import Button from '../../atoms/Button';
import Loader from '../../atoms/icons/Loader';
import { useTranslation } from 'react-i18next';
import InputItem from '../../molecules/InputItem';
import { noop } from 'lodash';
import axios from 'axios';
import styled, { useTheme } from 'styled-components';
import Notice from '../../molecules/Notice';
function updatePath(setAddresses) {
    return (index) => (path) => (event) => setAddresses(prevState => {
        const newState = [...prevState];
        // @ts-ignore
        newState[index][path] = event.target.value;
        return newState;
    });
}
const StyledLoader = styled(Loader) `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 28px;
    height: 28px;
`;
const StyledPlaceholder = styled.div `
    width: 100%;
    height: 340px;
`;
const AddressInfoModal = ({ dossier, open, onClose = noop, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [clientErrors, setClientErrors] = useState(null);
    const [serverError, setServerError] = useState(null);
    const [addresses, setAddresses] = useState([]);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const isLoading = hasLoaded === false;
    const uri = `/api/dossier/${dossier?.id}/address`;
    useEffect(() => {
        if (open === true && !hasLoaded) {
            axios
                .get(uri)
                .then(({ data }) => setAddresses(data))
                .then(() => setHasLoaded(true));
        }
    }, [open]);
    const saveAddress = (address) => (e) => {
        setIsSaving(true);
        e.preventDefault();
        axios
            .patch(uri, address)
            .then(() => {
            closeModal(true);
        })
            .catch(e => {
            if (e.response?.data?.errors) {
                setClientErrors(e.response?.data?.errors);
                return;
            }
            setServerError(e);
        })
            .finally(() => {
            setIsSaving(false);
        });
    };
    const closeModal = (_success) => {
        setClientErrors(null);
        setServerError(null);
        setHasLoaded(false);
        setAddresses([]);
        onClose(_success);
    };
    return (_jsx(_Fragment, { children: _jsxs(Modal, { title: t('address_info.title'), open: open, onClose: closeModal, children: [isLoading && (_jsx(StyledPlaceholder, { children: _jsx(StyledLoader, { color: (theme ?? {})['primary'] }) })), addresses.map((address, index) => {
                    return (_jsx("form", { onSubmit: e => saveAddress(addresses[index])(e), children: _jsxs("fieldset", { disabled: isSaving, style: { border: '0' }, children: [_jsxs(Flex, { gap: "20px", margin: "0 0 20px 0", children: [_jsx("div", { style: { flex: '1' }, children: _jsx(InputItem, { label: t('address_info.street'), value: address.street || '', onChange: updatePath(setAddresses)(index)('street'), autoComplete: "off" }) }), _jsx("div", { style: { flex: '1' }, children: _jsxs(Flex, { gap: "20px", children: [_jsx("div", { children: _jsx(InputItem, { label: t('address_info.house_number_abbr'), value: address.house_number ||
                                                                '', onChange: updatePath(setAddresses)(index)('house_number'), autoComplete: "off" }) }), _jsx("div", { children: _jsx(InputItem, { label: t('address_info.house_number_addition_abbr'), value: address.house_number_addition ||
                                                                '', onChange: updatePath(setAddresses)(index)('house_number_addition'), autoComplete: "off" }) })] }) })] }), _jsxs(Flex, { gap: "20px", margin: "0 0 20px 0", children: [_jsx("div", { style: { flex: '1' }, children: _jsx(InputItem, { label: t('address_info.zip_code'), value: address.postal_code || '', onChange: updatePath(setAddresses)(index)('postal_code'), autoComplete: "off" }) }), _jsx("div", { style: { flex: '1' }, children: _jsx(InputItem, { label: t('address_info.city'), value: address.city || '', onChange: updatePath(setAddresses)(index)('city'), autoComplete: "off" }) })] }), _jsx(Flex, { column: true, children: _jsx(Button, { secondary: true, fullWidth: true, textAlign: "center", type: "submit", isLoading: isLoading || isSaving, 
                                        //@ts-ignore
                                        loaderColor: theme.primary.dark, children: t('address_info.submit') }) })] }) }, address.relation_number));
                }), clientErrors && (_jsx("div", { style: { marginTop: '1rem' }, children: _jsx(Notice, { type: "error", title: t('address_info.client_error_notice_title'), children: _jsx("ul", { style: { listStyle: 'inside' }, children: Object.entries(clientErrors).map(([key, error]) => (_jsx("li", { children: error }, key))) }) }) })), serverError && (_jsx("div", { style: { marginTop: '1rem' }, children: _jsx(Notice, { type: "error", title: t('address_info.server_error_notice_title'), children: serverError.message }) }))] }) }));
};
export default AddressInfoModal;
